/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TaxVatRateRequest = {
    rate?: number;
    rateType?: TaxVatRateRequest.rateType;
    validFrom?: string;
    validTo?: string;
};

export namespace TaxVatRateRequest {

    export enum rateType {
        RATE_REDUCED2 = 'RATE_REDUCED2',
        RATE_REDUCED = 'RATE_REDUCED',
        RATE_BASE = 'RATE_BASE',
        RATE_0 = 'RATE_0',
    }


}

